import * as React from "react";
import moment from "moment";
import "./MessageList.scss";
import { ConversationPreview } from "../types";
import { User } from "../../session/types";
import { useSelector } from "react-redux";
import { RootState } from "../../types";

type Props = {
  conversationPreview: ConversationPreview;
};

const MessageList: React.FunctionComponent<Props> = ({ conversationPreview }: Props) => {
  const currentUser: User | null = useSelector(
    (state: RootState) => state.session.data.currentUser
  );
  const hidePatient = conversationPreview.participants.some(
    x => x.systemUserId === conversationPreview.patient.id
  );

  const getClassName = (id: string) => {
    if (id.startsWith("patient")) return "badge patient";
    if (id.startsWith("family")) return "badge family";
    return "";
  };

  return (
    <div className="entry">
      <div className="ellipsis bold flex-between">
        <div>
          {conversationPreview.participants
            .filter(x => x.systemUserId != currentUser?.id)
            .map<React.ReactNode>(n => (
              <span className={getClassName(n.systemUserId)}>{n.displayName}</span>
            ))
            .reduce((prev, curr) => [prev, ", ", curr])}
        </div>
        {conversationPreview.unread && (
          <div className="new-message-badge">
            <span className="little-circle">NEW</span>
          </div>
        )}
        {conversationPreview.readOnly && <i className="fas fa-comment-slash read-only"></i>}
      </div>
      {!hidePatient && (
        <div className="ellipsis patient-name">
          Patient: {conversationPreview.patient.givenName} {conversationPreview.patient.familyName}
        </div>
      )}
      <div className="ellipsis body">{conversationPreview.lastMessagePreview}</div>
      <div className="timestamp">{moment(conversationPreview.lastMessageSent).format("llll")}</div>
    </div>
  );
};

export default MessageList;
